import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/ContentPage";
import { IMAGES } from "@/lib/images";

export const Route = createFileRoute("/integritetspolicy")({
  head: () => ({
    meta: [
      { title: "Integritetspolicy | BBN Nordic" },
      { name: "description", content: "BBN Nordics integritetspolicy beskriver hur vi samlar in, lagrar och behandlar personuppgifter i enlighet med GDPR." },
      { property: "og:title", content: "Integritetspolicy | BBN Nordic" },
      { property: "og:description", content: "Så behandlar BBN Nordic dina personuppgifter enligt GDPR." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://bbnnordic.se/integritetspolicy" },
      { property: "og:image", content: "https://bbnnordic.se/og-default.jpg" },
    ],
    links: [{ rel: "canonical", href: "https://bbnnordic.se/integritetspolicy" }],
  }),
  component: () => (
    <ContentPage
      eyebrow="JURIDISKT"
      title="Integritetspolicy"
      subtitle="Så behandlar vi dina personuppgifter i enlighet med GDPR."
      heroImage={IMAGES.sakerhetsfilmHero}
      breadcrumbs={[{ label: "Integritetspolicy" }]}
      sections={[
        {
          eyebrow: "PERSONUPPGIFTSANSVARIG",
          heading: "Vem ansvarar för dina uppgifter?",
          paragraphs: [
            "BBN Nordic AB, org.nr 556914-8306, med adress Satellitvägen 16, 245 34 Staffanstorp, är personuppgiftsansvarig för behandlingen av dina personuppgifter.",
            "Har du frågor om vår behandling av personuppgifter kan du kontakta oss på info@bbnnordic.se eller 0771 502 502.",
          ],
        },
        {
          eyebrow: "INSAMLADE UPPGIFTER",
          heading: "Vilka uppgifter samlar vi in?",
          paragraphs: [
            "Vi samlar in uppgifter du själv lämnar till oss vid offertförfrågan, kontakt eller beställning: namn, företag, e-post, telefonnummer samt information om ditt projekt.",
          ],
          bullets: [
            "Kontaktuppgifter (namn, e-post, telefon)",
            "Företagsuppgifter och projektinformation",
            "Kommunikation och korrespondens",
            "Faktura- och leveransuppgifter",
          ],
        },
        {
          eyebrow: "ÄNDAMÅL OCH LAGLIG GRUND",
          heading: "Varför behandlar vi uppgifterna?",
          paragraphs: [
            "Uppgifterna används för att besvara förfrågningar, utföra installationer, fullgöra avtal och uppfylla rättsliga skyldigheter som bokföring. Laglig grund är avtal, berättigat intresse samt rättslig förpliktelse.",
          ],
        },
        {
          eyebrow: "DINA RÄTTIGHETER",
          heading: "Du har rätt att veta och påverka.",
          paragraphs: [
            "Du har rätt att begära registerutdrag, rättelse, radering, begränsning samt invända mot behandling. Klagomål kan lämnas till Integritetsskyddsmyndigheten (IMY).",
          ],
        },
      ]}
      related={[
        { to: "/cookiepolicy", label: "Cookiepolicy", desc: "Så använder vi cookies på webbplatsen." },
        { to: "/kontakt", label: "Kontakt", desc: "Hör av dig vid frågor om dina uppgifter." },
      ]}
    />
  ),
});
